import styled from 'styled-components'

const DragHandle = styled.button`
  position: absolute;
  left: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  border-radius: 0;
  color: inherit;
  background: transparent;
  box-shadow: none;
  appearance: none;
  touch-action: none;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`

export default DragHandle
